import React from 'react'
import { Suspense, lazy, useEffect, useState } from "react";
import { Accordion, Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import Pagination from "react-js-pagination";
import EventBus from "../../../../services/EventBus"
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { MathJax, MathJaxContext } from "better-react-mathjax";
// import AddSubQuetions from './AddSubQuetions';
import { GetAllSubQuetion, GetAllSubjects, deleteSubQuetion } from '../../../../services/CommonService';
const AddSubQuetions = lazy(() => import("./AddSubQuetions"))
function SubQuetions() {
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    const [subadminbar, setSubAdminbar] = useState(true);
    useEffect(() => {
        getallsubquestions();
        getSubjects()
        // getAllProgram();

        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");

        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN') {
            setSubAdminbar(false)
        }

    }, []);
    const [programcourses, setProgramcourses] = useState([]);
    const [postModal, setPostModal] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0)
    const [updatedata, setUpdateData] = useState({});
    const [programlist, setProgramList] = useState([]);
    const [postModal1, setPostModal1] = useState(false);
    const [courseData, setCourseData] = useState(false);
    const [courseDataType, setCourseDataType] = useState(null);
    const [answer1, setanswer1] = useState(null);
    const [answer2, setanswer2] = useState(null);
    const [answer3, setanswer3] = useState(null);
    const [answer4, setanswer4] = useState(null);
    const [percent, setPercent] = useState(50);
    const [subjects,setSubjects]=useState([])
    
    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn,
            query: {}
        }
        const respData = await GetAllSubQuetion(reqparams);
        setProgramcourses(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);
    }
    const getallsubquestions = async () => {
        const reqparams = {
            pageno: '1',
            query: {}
        }
        const respData = await GetAllSubQuetion(reqparams);
        setProgramcourses(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);
        // console.log("Questions data",respData.data.docs);
    }

    const getSubjects=async()=>{
        const reqparams = {
            pageno: '-1',
        }
        const ResponseData = await GetAllSubjects(reqparams);
        // console.log("Subjects Response",ResponseData.data);
        setSubjects(ResponseData?.data)


    }
    const openModal = async (item) => {
        //alert("hi");

        setUpdateData(item);
        let opts = item?.options;
        if (opts.length > 0) {
            const ans1 = opts.filter((t) => t.optid == 1);
            if (ans1.length > 0) {
                setanswer1(ans1[0].title);
            }
            const ans2 = opts.filter((t) => t.optid == 2);
            if (ans2.length > 0) {
                setanswer2(ans2[0].title);
            }

            const ans3 = opts.filter((t) => t.optid == 3);
            if (ans3.length > 0) {
                setanswer3(ans3[0].title);
            }

            const ans4 = opts.filter((t) => t.optid == 4);
            if (ans4.length > 0) {
                setanswer4(ans4[0].title);
            }
        } else {
            setanswer1(null);
            setanswer2(null);
            setanswer3(null);
            setanswer4(null);
        }
        setPostModal(true);
    }
    const addModal = async () => {
        setanswer1(null);
        setanswer2(null);
        setanswer3(null);
        setanswer4(null);

        setUpdateData({});
        setPostModal(true);
    }
    const closemodal = async () => {
        getallsubquestions();
        setPostModal(false);
    }
    const openCourseModal = async (item) => {
        setCourseData(item);
        setCourseDataType('ITPROGRAMING');
        setPostModal1(true);
    }

    const closemodal1 = async () => {
        getallsubquestions();
        setPostModal1(false);
    }
    const deleQuestions = async (item) => {


        const response = await deleteSubQuetion(item);


        if (response.data.id) {
            swal("Question deleted successfully", "success");
            getallsubquestions();
        } else {
            // notifyTopInfo("Profile data updated successfully");
            swal("Failed to delete question", "failure")
            //getPricings();

        }

    }

    const fields = {
        subjectname: '',

    }
    const [formfields, setFromFields] = useState(fields);

    const { subjectname } = formfields;


    const handleChange1 = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));


    }

    const submitForm = async () => {
        const reqparams = {
            pageno: 1,
            query: {  }
        }
        if(formfields.subjectname !=''){
            reqparams.query.subjectid = formfields.subjectname;
        }
        const ResponseData = await GetAllSubQuetion(reqparams)
        setProgramcourses(ResponseData.data.docs);
        setTotalRecords(ResponseData.data.totalDocs);

    }
    const resetform = async () => {
        setFromFields(fields)
        getallsubquestions()

    }
    return (
        <>
            <Col lg={12}>
                <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                    <Accordion.Item key={percent} eventKey={`${percent}`}>
                        <Accordion.Header className="accordion-header">
                            Search
                        </Accordion.Header>
                        <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                            <div className="accordion-body">
                                <div className="row">
                                    <div className="form-group mb-3 col-md-6">
                                        <label

                                            htmlFor="val-username"
                                        >
                                            Subject Name
                                        </label>

                                        <select className="form-control" name="subjectname"
                                            value={subjectname} onChange={handleChange1}>
                                            <option value=''>Select</option>
                                            {subjects?.map(item => (
                                                <option
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>



                                    </div>




                                    <br />
                                    <div className="form-group">
                                        <button onClick={submitForm} className="btn btn-primary" type="button"
                                        >Search</button>
                                        <button onClick={resetform} className="btn btn-warning" type="button"
                                        >Reset</button>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Collapse>
                    </Accordion.Item>

                </Accordion>
                <Card>
                    <Card.Header>
                        <Card.Title>Questions <Button onClick={() => addModal()}
                            className="me-2" variant="primary btn-square"
                            title="Add Question"
                        >
                            <span className="btn-icon-start text-danger">
                                <i className="fa fa-plus color-danger" />
                            </span>
                            ADD
                        </Button></Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th className="width80">
                                        <strong>Question No</strong>
                                    </th>
                                    <th>
                                        <strong>Question</strong>
                                    </th>

                                    <th>
                                        <strong>Question Type</strong>
                                    </th>
                                    <th>
                                        <strong>Difficulty level</strong>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {programcourses?.map(item => (
                                    <tr key={item.id}>
                                        <td>
                                            <strong>{item.questionno}</strong>
                                        </td>
                                        <td>
                                            {/* <div dangerouslySetInnerHTML={{ __html: item.title }} />*/}


                                            <MathJaxContext>
                                                <div dangerouslySetInnerHTML={{ __html: item.title }} />
                                            </MathJaxContext>

                                        </td>
                                        <td>{item.type}</td>
                                        <td>{item.difficultylevel}</td>

                                        <td>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    className="light sharp i-false"
                                                >
                                                    {svg1}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => openModal(item)}>
                                                        Edit

                                                    </Dropdown.Item >

                                                  {subadminbar &&  <Dropdown.Item onClick={() => deleQuestions(item)}>
                                                        Delete

                                                    </Dropdown.Item >}




                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                        <div >

                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={10}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                activeClass="active"
                                itemClass="page-item"
                                innerClass="pagination mb-0"
                                linkClass="page-link"
                                firstPageText="First"
                                lastPageText="Last"
                                prevPageText="Previous"
                                nextPageText="Next"
                                disabledClass="disabled"
                                activeLinkClass="disabled"
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Modal className="modal fade" size="xl" show={postModal} onHide={closemodal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">


                                <Suspense fallback={<div>Loading</div>}>
                                    <AddSubQuetions updateprop={updatedata} qanswer1={answer1}
                                        qanswer2={answer2} qanswer3={answer3} qanswer4={answer4} /> </Suspense>


                            </div>
                            {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
                        </form>

                    </div>
                </div>
            </Modal>

        </>
    )
}

export default SubQuetions